/* eslint-disable */
// @ts-nocheck
import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import Dropdown from '../Dropdown';
import Input from '../Input';
import QueryPartState from './QueryPartState';
import * as vendorHelpers from '../../../../../../shared/vendorHelpers';
import { getPlaceholder } from './luceneFormLabel';
import type { FilterType } from '../../../types/luceneTypes';
import type { AgencyAccessFilters } from '../../../../main/types/utilTypes';
import type { Event, SelectEvent } from './QueryPart.types';
import type { OptionWithLuceneQueryBuilderConfig } from './types';
import {
  areTermsNonEditable,
  getAccessFilterForKey,
  getDropdownValue,
  getOptionObjectForField,
  getOptions,
} from '../../../../main/components/PartnerManager/components/PostbackForm/PostbackDataMapper/FilterService/FiltersService';
import { ImageService } from '../../../../main/services/ImageService/ImageService';
type Props = {
  queryPartState: QueryPartState;
  index: number;
  onChange: (queryPartState: QueryPartState) => void;
  onDelete: () => void;
  options: Array<OptionWithLuceneQueryBuilderConfig>;
  getFilters: (field?: string | null | undefined) => Array<Record<string, any>>;
  agencyUser?: boolean | null | undefined;
  agencyId?: string | null | undefined;
  convertToHumanReadable: boolean;
  accessFilters: AgencyAccessFilters | null | undefined;
  isWebhook: boolean;
  className?: string;
  queryValueOptions?: Record<string, string[]>;
};

class QueryPart extends React.Component<Props> {
  _getProtectedTermsAndTypeForQueryPart = (
    queryPartState: QueryPartState
  ): {
    terms: Array<string>;
    type: FilterType;
  } => {
    const agencyUser = this.props.agencyUser;
    const accessFilters = this.props.accessFilters;
    const permission = vendorHelpers.protectedLuceneFieldsToPermissionKeys[queryPartState.field];
    const termsForAccessFilter = getAccessFilterForKey(permission, accessFilters);

    if (agencyUser && termsForAccessFilter && termsForAccessFilter.length > 0) {
      return {
        terms: termsForAccessFilter,
        type: 'equals',
      };
    }

    return {
      terms: queryPartState.terms,
      type: queryPartState.type,
    };
  };

  _onFieldSelectChange = (e: SelectEvent): void => {
    const newQueryPartState = new QueryPartState({
      terms: [],
      field: e.value === '_custom_' ? '' : e.value,
      type: 'equals',
      termMin: null,
      termMax: null,
    });
    this.props.onChange(newQueryPartState);
  };

  _onFieldInputChange = (e: Event): void => {
    const queryPartState = this.props.queryPartState;
    const userInput = e.target.value;
    queryPartState.field = userInput && userInput.trim();

    const values = this._getProtectedTermsAndTypeForQueryPart(queryPartState);

    queryPartState.terms = values.terms;
    queryPartState.type = values.type;
    this.props.onChange(queryPartState);
  };

  _onFilterSelectTypeChange = (e: SelectEvent): void => {
    const queryPartState = this.props.queryPartState;
    const type = e.value;

    // fixes unreachable state bug
    if (queryPartState.type.includes('range') && !type.includes('range')) {
      delete queryPartState.termMax;
      delete queryPartState.termMin;
      queryPartState.terms = [];
    }

    queryPartState.type = type;
    this.props.onChange(queryPartState);
  };

  _onTermSelectChange = (value: SelectEvent | Array<SelectEvent>, disableForAgencyUser: boolean): void => {
    const events = Array.isArray(value) ? value : [value];

    if (disableForAgencyUser && events.length === 0) {
      return;
    }

    const queryPartState = this.props.queryPartState;
    queryPartState.terms = events.map((event) => event.value);
    this.props.onChange(queryPartState);
  };

  _onTermInputChange = (e: Event): void => {
    const queryPartState = this.props.queryPartState;
    queryPartState.terms = [e.target.value];
    this.props.onChange(queryPartState);
  };

  _onMinRangeInputChange = (e: Event): void => {
    const queryPartState = this.props.queryPartState;
    queryPartState.termMin = e.target.value;
    this.props.onChange(queryPartState);
  };

  _onMaxRangeInputChange = (e: Event): void => {
    const queryPartState = this.props.queryPartState;
    queryPartState.termMax = e.target.value;
    this.props.onChange(queryPartState);
  };

  _renderHumanReadableType = (type: string) => {
    const filters = this.props.getFilters();
    return <span>{R.prop('label', R.find(R.propEq('value', type), filters))}</span>;
  };

  _renderHumanReadableField = (field: string, option: Record<string, any>) => {
    return <span className={'h_fw-600'}>{`${option.value === '_custom_' ? field : option.label} `}</span>;
  };

  _renderHumanReadableValues = (
    type: string,
    terms: Array<string>,
    termMin: string | null | undefined,
    termMax: string | null | undefined
  ) => {
    if (type.includes('exists')) {
      return '';
    }

    if (!type.includes('range')) {
      return terms.reduce((acc, term, i) => {
        return acc.concat([
          i ? <span key={`read-only-mode__comma-${i}`}>{`,`}</span> : null,
          <span className={'h_fw-600'} key={`read-only-mode__term-${i}`}>{` ${term}`}</span>,
        ]);
      }, []);
    }

    return (
      <span>
        {' from '}
        <span className={'h_fw-600'}>{termMin || ''}</span>
        {' to '}
        <span className={'h_fw-600'}>{termMax || ''}</span>
      </span>
    );
  };

  _renderHumanReadable = (
    field: string,
    option: Record<string, any>,
    type: string,
    terms: Array<string>,
    termMin: string | null | undefined,
    termMax: string | null | undefined
  ) => {
    return (
      <span>
        {this._renderHumanReadableField(field, option)}
        {this._renderHumanReadableType(type)}
        {this._renderHumanReadableValues(type, terms, termMin, termMax)}
      </span>
    );
  };

  _userCanCreateOptions = (disableForAgencyUser: boolean): boolean => {
    return !disableForAgencyUser;
  };

  render() {
    const { agencyUser, accessFilters, isWebhook, convertToHumanReadable, onDelete, className } = this.props;
    const { field, type, terms, termMin, termMax } = this.props.queryPartState;
    const option = getOptionObjectForField(field, this.props.options);
    const singleValueInput = option.config && option.config.singleValueInput;
    const singleValueDropdown = option.config && option.config.singleValueDropdown;

    if (convertToHumanReadable) {
      return this._renderHumanReadable(field, option, type, terms, termMin, termMax);
    }

    const accessFilterKey = vendorHelpers.protectedLuceneFieldsToPermissionKeys[field];
    const disableForAgencyUser = !!getAccessFilterForKey(accessFilterKey, accessFilters) && !!agencyUser;
    const partTermOptions = getOptions(field, this.props.options, this.props.queryValueOptions, accessFilters);

    const canCreateOptions = this._userCanCreateOptions(disableForAgencyUser);

    const termPlaceholder = getPlaceholder(partTermOptions, canCreateOptions);
    return (
      <div className={classNames('query-part__row', className)} data-testid={`filter-row-${this.props.index}`}>
        <Dropdown
          clearable={false}
          disabled={disableForAgencyUser}
          className="part-field-label"
          onChange={this._onFieldSelectChange}
          value={option.value}
          options={this.props.options}
          i13nLabel="Part Field Label"
          testid="part-field-label"
        />
        <Input
          testid="part-field-value"
          value={field}
          disabled={option.value !== '_custom_' || disableForAgencyUser}
          onChange={this._onFieldInputChange}
          className={classNames('part-field-value', {
            'part-field-value__illegal': !field,
          })}
          inputClassName="query-part__input"
          noFooter={true}
          i13nLabel="Query Part Value"
        />
        <Dropdown
          clearable={false}
          disabled={disableForAgencyUser}
          className="part-filter-type"
          onChange={this._onFilterSelectTypeChange}
          value={type}
          options={this.props.getFilters()}
          i13nLabel="Part Filter Type"
          testid="part-filter-type"
        />
        {type.includes('range') ? (
          <div className="h_d-f h_ai-c h_w-25">
            <Input
              testid="part-term-min"
              disabled={disableForAgencyUser}
              value={termMin}
              onChange={this._onMinRangeInputChange}
              className={classNames('part-term-range', {
                'part-term-range__illegal': !termMin,
              })}
              inputClassName="query-part__input"
              noFooter={true}
              i13nLabel="Query Part Range Min"
            />

            {' to '}

            <Input
              testid="part-term-max"
              disabled={disableForAgencyUser}
              value={termMax}
              onChange={this._onMaxRangeInputChange}
              className={classNames('part-term-range', {
                'part-term-range__illegal': !termMax,
              })}
              inputClassName="query-part__input"
              noFooter={true}
              i13nLabel="Query Part Range Max"
            />
          </div>
        ) : null}
        {type.includes('exist') || type.includes('range') ? null : singleValueInput ? (
          <Input
            testid="part-term"
            disabled={disableForAgencyUser}
            value={terms[0]}
            onChange={this._onTermInputChange}
            className={classNames('part-term-input', {
              'part-term-input__illegal': !terms[0],
            })}
            inputClassName="query-part__input"
            noFooter={true}
            i13nLabel="Query Part Term"
          />
        ) : (
          <Dropdown
            creatable={canCreateOptions}
            clearable={false}
            disabled={areTermsNonEditable(field, isWebhook, disableForAgencyUser)}
            className={classNames('part-term-dropdown', {
              'part-term-dropdown__illegal': !terms.filter(Boolean).length,
            })}
            multi={!singleValueDropdown}
            value={getDropdownValue(terms, singleValueDropdown)}
            onChange={(value) => this._onTermSelectChange(value, disableForAgencyUser)}
            i13nLabel="Query Part Term"
            testid="part-term"
            options={partTermOptions || []}
            placeholder={termPlaceholder}
            components={
              (!partTermOptions || !partTermOptions.length) && {
                DropdownIndicator: () => null,
              }
            }
          />
        )}
        {!disableForAgencyUser && (
          <img
            onClick={onDelete}
            data-testid="remove-filter__row-0"
            className="remove-filter-btn h_cur-p"
            src={ImageService.getImageUrl('/static/images/editor/ic_remove_button.svg')}
          />
        )}
      </div>
    );
  }
}

export default QueryPart;
